function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "0%",
  y1: "16.992%",
  x2: "100%",
  y2: "83.008%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.013 16.17l13.79 28.449c.492 1.013.036 2.218-1.018 2.69-1.054.473-2.306.035-2.798-.979l-3.016-6.223c-2.741-.663-5.765.037-7.91 2.1a2.168 2.168 0 01-2.981 0 1.974 1.974 0 010-2.869c2.433-2.34 5.619-3.517 8.808-3.53l-1.903-3.926c-3.347.407-6.584 1.846-9.154 4.319a2.168 2.168 0 01-2.982 0 1.974 1.974 0 010-2.869c2.918-2.807 6.515-4.564 10.282-5.27l-1.806-3.725a23.333 23.333 0 00-10.726 5.86 2.168 2.168 0 01-2.981 0 1.974 1.974 0 010-2.869 27.54 27.54 0 0111.897-6.725l-1.318-2.722c-.492-1.013-.036-2.218 1.018-2.69 1.054-.473 2.306-.035 2.798.979zm19.076 17.162a1.974 1.974 0 010 2.869 2.168 2.168 0 01-2.982 0 15.717 15.717 0 00-2.776-2.131l-2.705-5.581a20.055 20.055 0 018.463 4.843zm5.293-6.004a1.974 1.974 0 010 2.869 2.168 2.168 0 01-2.981 0c-3.662-3.522-8.242-5.62-13-6.295l-2.067-4.266c6.564.306 13.036 2.87 18.048 7.692z",
  id: "a"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10 -15)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h60v60H0z"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#b)",
  xlinkHref: "#a"
}));

function SvgNoWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgNoWifi);
export default __webpack_public_path__ + "static/media/no-wifi.1a3bd4e1.svg";
export { ForwardRef as ReactComponent };